import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { GrSearch } from "react-icons/gr";
import { CSS_CLASSES } from "../../../css-classes";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import FindGames from "../FindGames/FindGames";
import { makeAjax, url } from "../../../helpers/global_helper";
import { useSelector } from "react-redux";

const initSetting = { search_sm: null, default_class: null };

const Search = (props) => {
  const [state, setState] = useState({
    gameList: [],
    loading: false,
    searchTerm: "",
    fnSetting: initSetting,
    page: 1,
    lastPage: null,
  });

  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));

  const debounceTimer = useRef(null);

  const debouncedFetch = useCallback((searchWord, nextPage) => {
    if (!searchWord) return;
    setState((prev) => ({ ...prev, loading: true }));
    makeAjax(url.USER_API.listProviderGame, {
      all_games: true,
      search_term: searchWord,
      category_code: props.providerSlug ? "" : window.location.pathname.split("/")[1],
      provider_name: props.providerSlug || "",
      page: nextPage,
      per_page: 90,
    })
      .then((response) => {
        setState((prev) => ({
          ...prev,
          loading: false,
          gameList: response.data?.gameInfo?.data || [],
          lastPage: response.data?.gameInfo?.last_page,
        }));
      })
      .catch(() => setState((prev) => ({ ...prev, loading: false })));
  }, [props.providerSlug]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setState((prev) => ({ ...prev, searchTerm: value, page: 1 }));

    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => debouncedFetch(value, 1), 300);
  };

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      fnSetting: {
        ...prev.fnSetting,
        search_sm: componentSetting?.search?.["default-value"].toString(),
        default_class: componentSetting?.search?.["default-value"].toString(),
      },
    }));
  }, [componentSetting]);

  useEffect(() => {
    if (props.showFilter) setState((prev) => ({ ...prev, searchTerm: '' }));
  }, [props.showFilter]);

  const isPopupScrollableAtBottom = useCallback(() => {
    const popupContent = document.getElementById('popup-content');
    return popupContent && (popupContent.scrollTop + popupContent.clientHeight >= popupContent.scrollHeight * 0.8);
  }, []);

  const handlePopupScroll = useCallback(() => {
    if (isPopupScrollableAtBottom()) {
      debouncedFetch(state.searchTerm, state.page);
      setState((prev) => ({ ...prev, page: prev.page + 1 }));
    }
  }, [state.page, state.searchTerm, isPopupScrollableAtBottom, debouncedFetch]);

  useEffect(() => {
    const popupContent = document.getElementById('popup-content');

    if (popupContent) {
      popupContent.addEventListener('scroll', handlePopupScroll);
    }

    return () => {
      if (popupContent) {
        popupContent.removeEventListener('scroll', handlePopupScroll);
      }
    };
  }, [handlePopupScroll, state.page]);

  return (
    <div>
      {state.fnSetting['search_sm'] && (
        <div className='search-section'>
          <div className='container'>
            <div className={state.fnSetting['default_class']}>
              <form className={CSS_CLASSES.searchBar}>
                <input
                  type="text"
                  name="search_box"
                  value={state.searchTerm}
                  placeholder={props.t('find_your_games')}
                  onChange={handleSearchChange}
                  className="search-input text-find_games background-findgame_search"
                />
                <GrSearch />
              </form>
              {state.gameList.length > 0 && state.searchTerm && (
                <div className="search-game-result">
                  <div className="findYourGames">
                    <div className="findgames games" id="popup-content">
                      <FindGames findGames={state.gameList} loader={state.loading} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Search.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Search);
